import framePage from '../framePage';

function hideLoading($button, extraClasses) {
	framePage.allowSubmit = true;
	$button
		.addClass(extraClasses)
		.removeClass('loading')
		.removeAttr('aria-busy');
}

export default hideLoading;
